import { Navigate, Outlet, Route, Routes } from "react-router-dom"
import { DashboardUser } from "@hydrologiq/common/providers/FirebaseAuth"
import Providers from "@hydrologiq/shared/providers/Providers"
import { RouteProvider, Section } from "@hydrologiq/shared/providers/RouteProvider"
import ScrollToTop from "@hydrologiq/shared/ScrollToTop"
import System from "./views/System"
import { SystemProvider } from "./providers/SystemProvider"
import SystemSelection from "./components/selection/SystemSelection"
import Systems from "./views/Systems"
import SystemMonitoring from "./views/SystemMonitoring"
import SystemReporting from "./views/SystemReporting"
import SystemReport from "./views/SystemReport"
import SystemForecast from "./views/SystemForecast"
import SystemAlertsPerformance from "./views/SystemAlertsPerformance"
import Settings from "./views/Settings"
import { useGetFeature } from "@hydrologiq/shared/providers/helpers/useFeature"

function Routing(props: { basePath?: string; user?: DashboardUser; container?: React.RefObject<HTMLElement> }) {
  const sectionPath = "systems"
  const { basePath = sectionPath, container } = props
  const hideReports = useGetFeature("hide_reports_system")

  return (
    <>
      <ScrollToTop />
      <Routes>
        {!basePath && <Route path={sectionPath} element={<Navigate to={"/"} />} />}
        <Route
          path={basePath}
          element={
            <RouteProvider route={basePath} section={Section.SYSTEMS}>
              <Providers container={container} locationsProvider={false} forecastProvider={false} sitesProvider={false}>
                <SystemProvider>
                  <SystemSelection />
                </SystemProvider>
              </Providers>
            </RouteProvider>
          }
        >
          <Route index element={<Systems />} />
          <Route path=":systemId" element={<Outlet />}>
            <Route index element={<System />} />
            <Route path="forecasting" element={<SystemForecast />} />
            <Route path="monitoring" element={<SystemMonitoring />} />
            {!hideReports && <Route path="reporting" element={<SystemReport />} />}
            <Route path="download" element={<SystemReporting />} />
            <Route path="alerts" element={<SystemAlertsPerformance />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Route>
      </Routes>
    </>
  )
}

export default Routing
